<template>
  <div>
    <!-- <h1>Embedded Iframe Example</h1> -->
    <iframe v-lazy-load :data-src="iframeSrc" width="100%" height="820" frameborder="0" allowfullscreen>
    </iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframeSrc: 'https://dev-discountrules.iipl.app/spin-and-win' 
    };
  }
}
</script>